<template>
    <div>
        <v-container>
            <v-row no-gutters>
                <v-col :cols="8">
                    <h1 class="headline font-weight-light mb-3">
                        <router-link
                            class="link-a"
                            :to="{
                                path: '/Inventory/Stock/' + pages,
                                query: { q: form_query },
                            }"
                            >STOCK</router-link
                        >
                        / STOCK DETAIL
                    </h1>
                </v-col>
                <v-col :cols="4" class="text-right">
                    <v-text-field
                        v-model="form_search_singlepart"
                        label="Search Singlepart / Enter"
                        single-line
                        solo
                        rounded
                        dense
                        @keyup.enter="func_search_sg()"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-card outlined>
                <v-row>
                    <v-col cols="6">
                        <v-list-item three-line>
                            <v-list-item-content>
                                <div class="overline mb-4">
                                    {{ state_main.category_name }}
                                </div>
                                <v-list-item-title class="headline mb-1">{{
                                    state_main.part_description
                                }}</v-list-item-title>
                                <v-list-item-subtitle>{{
                                    state_main.part_name
                                }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                    <v-col cols="6">
                        <v-list-item three-line>
                            <v-list-item-content>
                                <div class="overline mb-4">
                                    SUPPLIER : {{ state_main.supplier_name }}
                                </div>
                                <v-list-item-title class="headline mb-1">{{
                                    state_main.project_name
                                }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-card>
            <!-- && (state_main.category_name === 'Toner' || state_main.category_name === 'Print Head') -->
            <div
                v-if="
                    params_type === 'onhand' &&
                        (team_name == 'INVENTORY' || team_name == 'ODM')
                "
            >
                <v-card class="mt-5">
                    <v-card-title>
                        <span class="headline headline-2 text-uppercase">
                            ON HAND
                        </span>
                    </v-card-title>

                    <v-row>
                        <v-col cols="12">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th>#</th>
                                            <th class="text-center">
                                                Shipment
                                            </th>
                                            <th class="text-center">
                                                Stock In
                                            </th>
                                            <th class="text-center">
                                                Qty Stock In
                                            </th>
                                            <th class="text-center">
                                                Qty Remaining
                                            </th>
                                            <th class="text-center">View</th>
                                            <th class="text-center">Print</th>
                                            <!-- <th
                                                class="text-center"
                                                v-if="team_name == 'INVENTORY'"
                                            >
                                                Del.
                                            </th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(item, index) in state_log"
                                            :key="index"
                                        >
                                            <td class="text-center">
                                                {{ index + 1 }}.
                                            </td>
                                            <td class="text-center">
                                                {{ item.shipment }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.created_date }}
                                                <br />
                                                {{ item.fullname }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.qty }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.onhand_stock.length }}
                                            </td>

                                            <td class="text-center">
                                                <v-btn
                                                    color="info"
                                                    x-small
                                                    fab
                                                    @click="
                                                        print(
                                                            item.stockin_id,
                                                            'data'
                                                        )
                                                    "
                                                >
                                                    <v-icon dark
                                                        >mdi-magnify</v-icon
                                                    >
                                                </v-btn>
                                            </td>
                                            <td class="text-center">
                                                <v-btn
                                                    x-small
                                                    fab
                                                    @click="
                                                        print(
                                                            item.stockin_id,
                                                            'print'
                                                        )
                                                    "
                                                >
                                                    <v-icon dark
                                                        >mdi-printer</v-icon
                                                    >
                                                </v-btn>
                                            </td>
                                            <!-- <td
                                                class="text-center"
                                                v-if="team_name == 'INVENTORY'"
                                            >
                                                <v-btn
                                                    @click="
                                                        del(item.stockin_id)
                                                    "
                                                    x-small
                                                    fab
                                                    color="red lighten-1"
                                                    ><v-icon
                                                        >mdi-minus</v-icon
                                                    ></v-btn
                                                >
                                            </td> -->
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card>
            </div>

            <div
                v-if="
                    (params_type === 'onhand' &&
                        team_name != 'INVENTORY' &&
                        team_name != 'ODM') ||
                        params_type === 'loan'
                "
            >
                <v-card class="mt-5">
                    <v-card-title>
                        <span class="headline headline-2 text-uppercase"
                            >{{ params_type }}
                        </span>
                    </v-card-title>
                    <v-row>
                        <v-col cols="12">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th>#</th>
                                            <th class="text-center">
                                                SinglePart
                                            </th>
                                            <th class="text-center">Serial</th>
                                            <th
                                                class="text-center"
                                                v-if="params_type === 'onhand'"
                                            >
                                                Location
                                            </th>
                                            <th
                                                class="text-center"
                                                v-if="params_type === 'loan'"
                                            >
                                                Case ID
                                            </th>
                                            <th class="text-center">
                                                branchname
                                            </th>
                                            <th
                                                class="text-center"
                                                v-if="params_type === 'loan'"
                                            >
                                                Engineer
                                            </th>
                                            <th
                                                class="text-center"
                                                v-if="params_type === 'onhand'"
                                            >
                                                Shipment
                                            </th>
                                            <th
                                                class="text-center"
                                                v-if="params_type === 'onhand'"
                                            >
                                                Stock In
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(item, index) in state_data"
                                            :key="item.singlepart"
                                        >
                                            <td class="text-center">
                                                {{ index + 1 }}.
                                            </td>
                                            <td class="text-center">
                                                {{ item.singlepart }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.serial }}
                                            </td>
                                            <td v-if="params_type === 'onhand'">
                                                {{ item.location }}
                                            </td>
                                            <td v-if="params_type === 'loan'">
                                                {{ item.case_id }}
                                            </td>
                                            <td>{{ item.branch_name }}</td>
                                            <td v-if="params_type === 'loan'">
                                                {{ item.engineer }}
                                            </td>
                                            <td v-if="params_type === 'onhand'">
                                                {{ item.shipment }}
                                            </td>

                                            <td
                                                class="text-center"
                                                v-if="params_type === 'onhand'"
                                            >
                                                {{ item.emp_name_en }}
                                                <br />
                                                <v-chip x-small>
                                                    {{ item.created_date }}
                                                </v-chip>
                                            </td>
                                        </tr>
                                        <br />
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card>
            </div>

            <div v-if="params_type == 'hub' || params_type == 'defective'">
                <template v-if="chk_search_branch === 0">
                    <v-row class="mt-3" v-if="branch.length > 0">
                        <v-col
                            cols="6"
                            sm="5"
                            md="3"
                            class="cur-p"
                            v-for="row in branch"
                            :key="row.branch_id"
                        >
                            <v-card
                                @click="
                                    get_data_hub(row.branch_id, row.branch_name)
                                "
                                :color="
                                    row.branch_id === chk_btn
                                        ? 'teal accent-1'
                                        : ''
                                "
                            >
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <b>{{ row.branch_name }}</b>
                                    </v-list-item-content>
                                    <v-btn
                                        fab
                                        dark
                                        small
                                        color="teal accent-3"
                                        >{{ row.qty }}</v-btn
                                    >
                                </v-list-item>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row v-if="engineer.length > 0" class="mt-3">
                        <v-col cols="12">
                            <hr />
                        </v-col>
                        <v-col
                            cols="6"
                            sm="5"
                            md="3"
                            class="cur-p"
                            v-for="row in engineer"
                            :key="row.branch_id"
                        >
                            <v-card
                                @click="
                                    get_data_hub(row.branch_id, row.branch_name)
                                "
                                :color="
                                    row.branch_id === chk_btn
                                        ? 'teal accent-1'
                                        : ''
                                "
                            >
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <b>{{ row.branch_name }}</b>
                                    </v-list-item-content>
                                    <v-btn
                                        fab
                                        dark
                                        small
                                        color="teal accent-3"
                                        >{{ row.qty }}</v-btn
                                    >
                                </v-list-item>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>

                <v-card class="mt-3" v-if="show_hub === true">
                    <v-card-title>
                        <span class="headline headline-2 text-uppercase"
                            >{{ show_name }}
                        </span>
                    </v-card-title>
                    <v-row>
                        <v-col cols="12" v-if="params_type == 'hub'">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center">#</th>
                                            <th class="text-center">
                                                SinglePart
                                            </th>
                                            <th class="text-center">Serial</th>
                                            <th class="text-center">Date</th>
                                            <th class="text-center">
                                                Update At
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(item, index) in branch_data"
                                            :key="item.singlepart"
                                        >
                                            <td class="text-center">
                                                {{ index + 1 }}.
                                            </td>
                                            <td class="text-center">
                                                <v-btn
                                                    @click="
                                                        change_transfer(
                                                            item.singlepart
                                                        )
                                                    "
                                                    rounded
                                                    small
                                                    color="teal lighten-2"
                                                    v-if="
                                                        item.location ===
                                                            'engineer'
                                                    "
                                                >
                                                    {{ item.singlepart }}</v-btn
                                                >
                                                <span v-else>{{
                                                    item.singlepart
                                                }}</span>
                                            </td>
                                            <td class="text-center">
                                                {{ item.serial }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.created_date }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.updated_date }}
                                            </td>
                                        </tr>
                                        <br />
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>

                        <v-col cols="12" v-if="params_type == 'defective'">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th>#</th>
                                            <th class="text-center">
                                                SinglePart
                                            </th>
                                            <th class="text-center">Serial</th>
                                            <th class="text-center">Case ID</th>
                                            <th class="text-center">Branch</th>
                                            <th class="text-center">
                                                Engineer
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(item, index) in branch_data"
                                            :key="item.singlepart"
                                        >
                                            <td class="text-center">
                                                {{ index + 1 }}.
                                            </td>
                                            <td class="text-center">
                                                {{ item.singlepart }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.serial }}
                                            </td>
                                            <td>
                                                {{ item.case_id }}
                                            </td>
                                            <td>{{ item.branch_name }}</td>
                                            <td>
                                                {{ item.engineer }}
                                            </td>
                                        </tr>
                                        <br />
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card>
            </div>
        </v-container>

        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card tile>
                    <v-toolbar flat dark color="primary">
                        <v-btn icon dark @click="close_dialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col cols="3">
                                <v-select
                                    :items="data_project"
                                    v-model="form_search.project"
                                    item-text="project_name"
                                    item-value="project_id"
                                    menu-props="auto"
                                    label="Select Project"
                                    hide-details
                                    dense
                                    outlined
                                    @change="get_category()"
                                ></v-select>
                            </v-col>
                            <v-col cols="3">
                                <v-select
                                    :items="data_category"
                                    v-model="form_search.category"
                                    item-text="category_name"
                                    item-value="category_id"
                                    menu-props="auto"
                                    label="Select Category"
                                    hide-details
                                    dense
                                    outlined
                                    @change="get_part()"
                                ></v-select>
                            </v-col>
                            <v-col cols="3">
                                <v-select
                                    :items="data_part"
                                    v-model="form_search.part"
                                    item-text="part_description"
                                    item-value="part_id"
                                    menu-props="auto"
                                    label="Select Part"
                                    hide-details
                                    dense
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="3" class="text-right">
                                <v-btn
                                    rounded
                                    small
                                    color="green accent-2"
                                    :disabled="
                                        form_del.length == 0 ||
                                            form_search.part == ''
                                    "
                                    @click="move_singlepart()"
                                >
                                    {{
                                        "Move : " +
                                            form_del.length +
                                            " Singpart"
                                    }}</v-btn
                                >
                            </v-col>
                            <v-col cols="12">
                                <hr />
                            </v-col>
                            <v-col cols="12" class="text-right">
                                <v-btn
                                    rounded
                                    small
                                    color="red accent-2"
                                    :disabled="form_del.length == 0"
                                    @click="del_singpart()"
                                >
                                    {{
                                        "Delete : " +
                                            form_del.length +
                                            " Singpart"
                                    }}</v-btn
                                >
                            </v-col>
                            <v-col cols="12">
                                <v-simple-table class="table-inv">
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                                <th class="text-center">
                                                    <v-btn
                                                        rounded
                                                        small
                                                        :color="
                                                            chk_all == true
                                                                ? 'green'
                                                                : ''
                                                        "
                                                        @click="
                                                            func_chk_singlepart()
                                                        "
                                                        >All</v-btn
                                                    >
                                                </th>
                                                <th>#</th>
                                                <th class="text-center">
                                                    SinglePart
                                                </th>
                                                <th class="text-center">
                                                    Serial
                                                </th>
                                                <th
                                                    class="text-center"
                                                    v-if="
                                                        params_type === 'onhand'
                                                    "
                                                >
                                                    Location
                                                </th>
                                                <th
                                                    class="text-center"
                                                    v-if="
                                                        params_type === 'loan'
                                                    "
                                                >
                                                    Case ID
                                                </th>
                                                <th class="text-center">
                                                    branchname
                                                </th>
                                                <th
                                                    class="text-center"
                                                    v-if="
                                                        params_type === 'loan'
                                                    "
                                                >
                                                    Engineer
                                                </th>
                                                <th
                                                    class="text-center"
                                                    v-if="
                                                        params_type === 'onhand'
                                                    "
                                                >
                                                    Shipment
                                                </th>
                                                <th
                                                    class="text-center"
                                                    v-if="
                                                        params_type === 'onhand'
                                                    "
                                                >
                                                    Stock In
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(item,
                                                index) in data_print"
                                                :key="item.singlepart"
                                            >
                                                <td class="text-center">
                                                    <v-switch
                                                        v-model="form_del"
                                                        :value="item.singlepart"
                                                    ></v-switch>
                                                </td>
                                                <td class="text-center">
                                                    {{ index + 1 }}.
                                                </td>
                                                <td class="text-center">
                                                    {{ item.singlepart }}
                                                </td>
                                                <td class="text-center">
                                                    {{ item.serial }}
                                                </td>
                                                <td
                                                    v-if="
                                                        params_type === 'onhand'
                                                    "
                                                >
                                                    {{ item.location }}
                                                </td>
                                                <td
                                                    v-if="
                                                        params_type === 'loan'
                                                    "
                                                >
                                                    {{ item.case_id }}
                                                </td>
                                                <td>{{ item.branch_name }}</td>
                                                <td
                                                    v-if="
                                                        params_type === 'loan'
                                                    "
                                                >
                                                    {{ item.engineer }}
                                                </td>
                                                <td
                                                    v-if="
                                                        params_type === 'onhand'
                                                    "
                                                >
                                                    {{ item.shipment }}
                                                </td>

                                                <td
                                                    class="text-center"
                                                    v-if="
                                                        params_type === 'onhand'
                                                    "
                                                >
                                                    {{ item.emp_name_en }}
                                                    <br />
                                                    <v-chip x-small>
                                                        {{ item.created_date }}
                                                    </v-chip>
                                                </td>
                                            </tr>
                                            <br />
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <div style="flex: 1 1 auto"></div>
                </v-card>
            </v-dialog>
        </v-row>

        <div id="printDiv">
            <div
                v-for="(row_print, indexP) in data_print"
                :key="indexP"
                style="padding: 0px; float: left; width: 33.333%"
            >
                <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                    style="
                        padding: 0px !important;
                        border-width: 1px;
                        border-left-style: dashed;
                        border-bottom-style: dashed;
                        border-right-style: dashed;
                        border-top-style: dashed;
                    "
                >
                    <tr>
                        <td width="100%" align="right" colspan="2">
                            <br />
                            <span style="font-size: 16px; margin-right: 10px">
                                {{
                                    row_print.project_name +
                                        " | " +
                                        row_print.part_description
                                }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td width="100%" align="right" colspan="2">
                            <span style="font-size: 22px; margin-right: 10px"
                                ><b>{{
                                    "Singlepart  : " + row_print.singlepart
                                }}</b></span
                            >
                        </td>
                    </tr>
                    <tr>
                        <td width="50%" align="center">
                            <qr-code
                                :text="row_print.singlepart"
                                :size="55"
                                style="float: right"
                            ></qr-code>
                        </td>
                        <td width="46%" align="center">
                            <barcode
                                style="float: right"
                                v-bind:value="row_print.singlepart"
                                width="1"
                                height="55"
                                font-size="12"
                            >
                            </barcode>
                        </td>
                    </tr>
                    <tr>
                        <td width="100%" align="right" colspan="2">
                            <span style="font-size: 15px; margin-right: 10px">{{
                                "Case ID : ......................................."
                            }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td width="100%" align="right" colspan="2">
                            <br />
                        </td>
                    </tr>
                    <tr>
                        <td width="100%" align="right" colspan="2">
                            <span
                                style="
                                    font-size: 15px;
                                    margin-right: 10px;
                                    margin-top: 10px;
                                "
                                >{{
                                    "RMA No : ......................................."
                                }}</span
                            >
                        </td>
                    </tr>
                    <tr>
                        <td width="100%" align="right" colspan="2">
                            <br />
                            <b style="margin-right: 10px"
                                ><span style="font-size: 13px"
                                    >Stock in date :
                                    {{ row_print.stockin_date }}
                                    <br /> </span
                            ></b>
                        </td>
                    </tr>
                    <tr>
                        <td width="100%" align="right" colspan="2">
                            <br />
                        </td>
                    </tr>
                </table>

                <div
                    :class="
                        indexP + 1 != 1 && (indexP + 1) % 12 === 0
                            ? 'break-after'
                            : ''
                    "
                ></div>
            </div>

            <div id="snackbar" class="d-print-none">
                <v-snackbar v-model="snackbar" color="success" right>
                    {{ text }}
                </v-snackbar>
            </div>
            <!-- <div class="break-after">1</div>
            <div class="break-before">2</div>
            <div class="break-before">3</div> -->
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import VueBarcode from "vue-barcode"

const url = `${process.env.VUE_APP_ROOT_API}/api/part`
const urlx = `${process.env.VUE_APP_ROOT_API}/api/`
const url_log = `${process.env.VUE_APP_ROOT_API}/api/log-stockin`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
        this.pages = this.$route.params.pages
        this.params_type = this.$route.params.type
        if (this.$route.params.branch != undefined) {
            this.get_data_hub_2()
            this.chk_search_branch = this.$route.params.branch
        }
        this.form_query = this.$route.query.q
    },
    components: {
        barcode: VueBarcode,
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            this.mutateIsLoading()
            let data = await axios.get(
                url +
                    "/" +
                    this.$route.params.type +
                    "/" +
                    this.$route.params.id,
                this.tk
            )

            let types = this.$route.params.type

            if (types === "onhand") {
                this.state_main = data.data[0]
                this.state_data = this.state_main.onhand
                await axios
                    .get(`${url_log}/${this.$route.params.id}`, this.tk)
                    .then((response) => {
                        this.state_log = response.data
                    })
                // if (
                //     this.state_main.category_name == "Toner" ||
                //     this.state_main.category_name == "Print Head"
                // ) {
                //     await axios
                //         .get(`${url_log}/${this.$route.params.id}`, this.tk)
                //         .then((response) => {
                //             this.state_log = response.data
                //         })
                // }
            } else if (types === "loan") {
                this.state_main = data.data[0]
                this.state_data = this.state_main.loan
            } else if (types === "hub") {
                this.state_main = data.data.part[0]
                this.branch = data.data.branch
                this.engineer = data.data.engineer
            } else if (types === "defective") {
                this.state_main = data.data.part[0]
                this.branch = data.data.branch
            }
            this.mutateIsLoading()
        },
        async get_data_hub(branch_id, branch_name) {
            this.mutateIsLoading()
            await axios
                .get(
                    url +
                        "/" +
                        this.$route.params.type +
                        "/" +
                        this.$route.params.id +
                        "/" +
                        branch_id,
                    this.tk
                )
                .then((response) => {
                    this.mutateIsLoading()
                    let data_show =
                        response.data[0].hub === undefined
                            ? response.data[0].defective
                            : response.data[0].hub

                    this.branch_data = data_show
                    this.show_name = branch_name
                    this.show_hub = true
                    this.chk_btn = branch_id

                    // console.log(this.branch_data, "-branch_data")
                })
        },
        async get_data_hub_2() {
            this.mutateIsLoading()
            let data_b = await axios.get(
                `${process.env.VUE_APP_ROOT_API}/api/branch/` +
                    this.$route.params.branch,
                this.tk
            )
            let data = await axios.get(
                url +
                    "/" +
                    this.$route.params.type +
                    "/" +
                    this.$route.params.id +
                    "/" +
                    this.$route.params.branch,
                this.tk
            )

            let data_show =
                data.data[0].hub === undefined
                    ? data.data[0].defective
                    : data.data[0].hub
            this.branch_data = data_show

            this.show_name = data_b.data.branch_name
            this.show_hub = true
            this.chk_btn = data_b.data.branch_id
            this.mutateIsLoading()
        },
        async print(stockin_id, st) {
            this.mutateIsLoading()

            await axios
                .get(
                    `${process.env.VUE_APP_ROOT_API}/api/log-stockin-detail/` +
                        stockin_id
                )
                .then((response) => {
                    this.data_print = response.data
                    if (st == "print") {
                        setTimeout(() => {
                            const localOptions = {
                                name: "_blank",
                                specs: [
                                    "fullscreen=yes",
                                    "titlebar=yes",
                                    "scrollbars=no",
                                ],
                                styles: [
                                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                                    "https://aitt.netlify.app/barcode.css",
                                ],
                            }
                            // const localOptions = {
                            //     styles: [
                            //         "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                            //
                            //     ],
                            // }

                            this.$htmlToPaper(
                                "printDiv",
                                localOptions,
                                () => {}
                            )
                        }, 500)
                    } else {
                        this.dialog = true
                        this.get_project()
                    }

                    this.mutateIsLoading()
                })
        },
        change_transfer(singlepart) {
            this.$swal({
                title: "Are you sure return to stock ?",
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    axios
                        .post(
                            `${process.env.VUE_APP_ROOT_API}/api/return-to-stock/` +
                                singlepart,
                            {},
                            this.tk
                        )
                        .then((response) => {
                            this.get_data_hub(this.chk_btn, this.show_name)
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        del(stockin_id) {
            this.$swal({
                title: "Are you sure you delete  ?",
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    axios
                        .delete(
                            `${process.env.VUE_APP_ROOT_API}/api/log-stockin-detail/` +
                                stockin_id
                        )
                        .then((response) => {
                            this.mutatesnackbar()
                            this.get_data()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                        })
                }
            })
        },
        close_dialog() {
            this.chk_all = false
            this.data_project = []
            this.data_category = []
            this.data_part = []
            this.form_search = {
                project: "",
                category: "",
                part: "",
            }
            this.form_del = []
            this.dialog = false
        },
        del_singpart() {
            this.$swal({
                title: "Are you sure you delete  ?",
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    axios
                        .post(
                            `${process.env.VUE_APP_ROOT_API}/api/delete-singlepart`,
                            { singlepart: this.form_del },
                            this.tk
                        )
                        .then((response) => {
                            console.log(response.data)
                            this.mutatesnackbar()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                            if (response.data.status == "Y") {
                                this.close_dialog()
                                this.get_data()
                            } else {
                                this.$root.$router.push({
                                    path: "/Inventory/Stock/" + this.pages,
                                    query: { q: this.form_query },
                                })
                            }
                        })
                }
            })
        },
        move_singlepart() {
            this.$swal({
                title: "Are you sure you move singlepart ?",
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    axios
                        .post(urlx + "move-singlepart", {
                            part_id: this.form_search.part,
                            singlepart: this.form_del,
                        })
                        .then((response) => {
                            this.mutatesnackbar()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                            // console.log(response.data)
                            if (response.data.status == "Y") {
                                this.close_dialog()
                                this.get_data()
                            } else {
                                this.$root.$router.push({
                                    path: "/Inventory/Stock/" + this.pages,
                                    query: { q: this.form_query },
                                })
                            }
                        })
                }
            })
        },
        async func_search_sg() {
            let routeData = this.$router.resolve({
                path: "/Search-Parts",
                query: { q: this.form_search_singlepart },
            })
            window.open(routeData.href, "_blank")
        },
        async get_project() {
            await axios
                .get(urlx + "alternative-part/get-project", this.tk)
                .then((response) => {
                    this.data_project = response.data
                })
        },
        async get_category(i) {
            await axios
                .get(
                    urlx +
                        "alternative-part/get-category/" +
                        this.form_search.project,
                    this.tk
                )
                .then((response) => {
                    this.data_category = response.data
                })
        },
        async get_part(i) {
            await axios
                .get(
                    urlx +
                        "alternative-part/get-part/" +
                        this.form_search.project +
                        "/" +
                        this.form_search.category,
                    this.tk
                )
                .then((response) => {
                    this.data_part = response.data
                })
        },
        func_chk_singlepart() {
            if (this.chk_all == true) {
                this.form_del = []
                this.chk_all = false
            } else {
                this.data_print.map((each, index) => {
                    this.form_del.push(each.singlepart)
                })
                this.chk_all = true
            }
        },
    },
    data() {
        return {
            isAndroid: "xx",
            dialog: false,
            state_main: [],
            state_data: [],
            state_log: [],
            data_print: [],
            branch: [],
            engineer: [],
            branch_data: [],
            show_hub: false,
            show_name: "",
            chk_btn: "",
            pages: 0,
            chk_search_branch: 0,
            team_name: localStorage.team_name,
            tk: "",
            params_type: null,
            form_query: null,
            form_del: [],
            text: "Success, Your work has been saved",
            form_search_singlepart: "",
            chk_all: false,
            data_project: [],
            data_category: [],
            data_part: [],
            form_search: {
                project: "",
                category: "",
                part: "",
            },
        }
    },
}
</script>
<style scoped>
#printDiv {
    display: none;
}
</style>
